import activity from "@/converters/activity";
import calendar from "@/converters/calendar";
import categories from "@/converters/categories";
import coreNews from "@/converters/coreNews";
import departments from "@/converters/departments";
import externalGroups from "@/converters/externalGroups";
import groups from "@/converters/groups";
import medias from "@/converters/medias";
import people from "@/converters/people";
import pictograms from "@/converters/pictograms";
import plannerCategories from "@/converters/plannerCategories";
import plannerFilters from "@/converters/plannerFilters";
import shared from "@/converters/shared";
import workSchedule from "@/converters/workSchedule";

export default {
  activity,
  calendar,
  categories,
  coreNews,
  departments,
  externalGroups,
  groups,
  medias,
  people,
  pictograms,
  plannerCategories,
  plannerFilters,
  shared,
  workSchedule,
};
